import type { ItemAssessmentScope } from "../assessment.ts";

export const JobStatuses = [
  "ASSIGNING",
  "COLLECTING",
  "COMPLETED",
  "CREATED",
  "DETECTING",
  "MANAGING",
  "GRAPHING",
  "ERRORED_ERRORED",
  "ERRORED",
  "PREPARING",
] as const;
export type JobStatus = (typeof JobStatuses)[number];

export const TerminalAssessmentStatuses = [
  "COMPLETED",
  "ERRORED",
  "ERRORED_ERRORED",
] as const;

export type AssessmentJobBase = {
  requestedTimestamp: number;
  scope: ItemAssessmentScope[];
  jobId: string;
  assessmentId: string;
  error?: { message: string };
};

export type AssessmentJob = AssessmentJobBase & {
  lastUpdatedTimestamp: number;
  status: JobStatus;
};

export const AssessmentProgressStatuses = [
  "COMPLETED",
  "IN_PROGRESS",
  "NOT_STARTED",
  "ERRORED",
] as const;
export type AssessmentProgressStatus =
  (typeof AssessmentProgressStatuses)[number];

export const AssessmentProgressTypes = [
  "PREPARATION",
  "DATA_COLLECTION",
  "GRAPHING",
  "DETECTION",
  "ASSIGNMENT",
  "MANAGEMENT",
] as const;
export type AssessmentProgressType = (typeof AssessmentProgressTypes)[number];

type AssessmentProgressDescription = {
  inProgress: string;
  completed: string;
};

export const AssessmentProgressTypeDescription: Record<
  AssessmentProgressType,
  AssessmentProgressDescription
> = {
  PREPARATION: {
    inProgress: "Preparing Data Sources",
    completed: "Data Sources Prepared",
  },
  DATA_COLLECTION: {
    inProgress: "Collecting Data",
    completed: "Data Collected",
  },
  GRAPHING: {
    inProgress: "Constructing IAM Graph",
    completed: "IAM Graph Built",
  },
  DETECTION: {
    inProgress: "Evaluating Monitors",
    completed: "Monitors Evaluated",
  },
  ASSIGNMENT: {
    inProgress: "Assigning Findings",
    completed: "Findings Assigned",
  },
  MANAGEMENT: {
    inProgress: "Handling managed findings",
    completed: "Managed Findings",
  },
};

export type AssessmentProgress = {
  name: AssessmentProgressType;
  progress: number;
  lastUpdatedTimestamp: object;
  startedTimestamp?: object;
  createdTimeStamp: object;
  state: AssessmentProgressStatus;
  message?: string;
  assessmentId?: string;
};
